import { makeStyles } from 'tss-react/mui';

export const SsoStyles = makeStyles()({
  logo: {
    width: '35px',
    height: '35px',
    cursor: 'pointer',
  },
});
